import {
  QuestionBase,
  QuestionControlOptions
} from '../question-types/question-base';
import { ValueMapper, ValueMapperFunction } from './question-utils';

export interface MultiselectControlOptions<T>
  extends QuestionControlOptions<T[]> {
  options?: T[];
  placeholder?: string;
  selectAllLabel?: string;
  noResultsLabel?: string;
  keyMapper?: ValueMapper<T>;
  labelMapper?: ValueMapper<T>;
  valueMapper?: ValueMapperFunction<number>;
}

export class MultiselectQuestion<T> extends QuestionBase<T[]>
  implements MultiselectControlOptions<T> {
  controlType = 'multiselect';
  options: T[] = [];
  placeholder?: string;
  selectAllLabel?: string;
  noResultsLabel?: string;
  keyMapper?: ValueMapper<T>;
  labelMapper?: ValueMapper<T>;
  valueMapper?: ValueMapperFunction<number>;
  // Meaningless validation
  isValid = true;

  constructor(options: MultiselectControlOptions<T>) {
    super(options);
    this.placeholder = options.placeholder || '';
    this.options = options.options || [];
    this.selectAllLabel = options.selectAllLabel;
    this.noResultsLabel = options.noResultsLabel;
    this.keyMapper = options.keyMapper;
    this.labelMapper = options.labelMapper;
    this.valueMapper = options.valueMapper;
  }
}
